import React from 'react';
import { Col, Card, Placeholder } from 'react-bootstrap';

const ShopCardSkeleton = () => {
  return (
    <Col lg="4" xl="3" md="4" sm="6" xs="6" className="mt-1 position-relative">
      <Card className="ShopsCards mt-3" style={{ border: 'none', boxShadow: '0px 0px 5px 1px rgba(0, 0, 0, 0.1)' }}>
        {/* Image Placeholder */}
        <div className="w-100" style={{ height: "140px", overflow: "hidden", borderTopLeftRadius: "5px", borderTopRightRadius: "5px" }}>
          <Placeholder as="div" animation="glow" className="w-100 h-100">
             <Placeholder xs={12} className="w-100 h-100" style={{ backgroundColor: "#e9ecef" }} />
          </Placeholder>
        </div>
        
        <Card.Body className="p-2">
          {/* Share Button Placeholder */}
          <Placeholder as="div" animation="glow" className="d-flex justify-content-end mb-2">
            <Placeholder.Button variant="primary" xs={4} size="sm" style={{ height: '20px', borderRadius: '4px' }} />
          </Placeholder>

          {/* Title Placeholder */}
          <Placeholder as={Card.Title} animation="glow" className="d-flex justify-content-between mb-2">
            <Placeholder xs={6} />
            <Placeholder xs={3} />
          </Placeholder>

          {/* Subtitle/Address Placeholder */}
          <Placeholder as={Card.Text} animation="glow" className="d-flex justify-content-between mb-3">
            <Placeholder xs={7} />
            <Placeholder xs={2} />
          </Placeholder>

          {/* Action Buttons Placeholder */}
          <div className="d-flex justify-content-between mt-3">
            <Placeholder.Button variant="primary" xs={5} size="sm" style={{ height: '25px', borderRadius: '4px' }} />
            <Placeholder.Button variant="light" xs={5} size="sm" style={{ height: '25px', borderRadius: '4px', backgroundColor: "#e9ecef", border: "none" }} />
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default ShopCardSkeleton;
